import { FC } from 'react'
import { useIsMobile } from '../hooks/useIsMobile'
import { Layout } from './Layout'
import { Navigation } from '../components/Navigation'
import { Text } from '../components/Text'
import { useTheme } from '../providers/useTheme'
import { useAppCtx } from '../providers/useAppCtx'
import { Html } from '../components/Html'
import { useTranslations } from '../hooks/useTranslations'
import { useContentQuery } from '../hooks/useContentQuery'

export type TermsAndConditionsProps = {
  'aria-label'?: {
    nav: string
    footer: string
  }
}

export const TermsAndConditions: FC<TermsAndConditionsProps> = ({
  'aria-label': ariaLabelProp = {
    nav: 'Main navigation',
    footer: 'Footer navigation',
  },
}) => {
  const { languages, votesCount } = useAppCtx()
  const { data: sequence = {} } = useContentQuery('sequence')
  const { data: navDic = {} } = useTranslations('navigation')
  const { data: legalDic = {} } = useTranslations('legal')
  const { colors } = useTheme()
  const isMobile = useIsMobile()
  const isVoting = sequence?.sequenceType === 'voting'

  return (
    <Layout
      style={{
        padding: '32px 24px 96px',
        justifyContent: 'start',
        alignSelf: isMobile ? 'center' : undefined,
        gap: 16,
      }}
    >
      <Layout.Navbar>
        <Navigation
          as="nav"
          aria-label={ariaLabelProp.nav}
          isCartVisible={isVoting}
          isExpandable
          cartItems={votesCount}
          languages={languages}
        />
      </Layout.Navbar>

      <Layout.Top>
        <Text color="gradient" variant="title" isMultiline>
          {navDic.terms_and_conditions_title}
        </Text>
      </Layout.Top>

      <Layout.Middle>
        <Html color={colors.textSecondary} variant="subheading-regular">
          {legalDic.terms_and_conditions}
        </Html>
      </Layout.Middle>

      <Layout.Footer>
        <Navigation
          as="footer"
          aria-label={ariaLabelProp.footer}
          languages={languages}
        />
      </Layout.Footer>
    </Layout>
  )
}
